import React, { useState } from 'react';
import { HousingPosting, UnifiedCard } from '../UnifiedCard';

interface HousingPreviewProps {
  postings: HousingPosting[];
  signedIn: boolean;
  favoriteKeys?: string[];
}

export function HousingPreview({ postings, signedIn, favoriteKeys = [] }: HousingPreviewProps) {
  const [visiblePostings, setVisiblePostings] = useState(() =>
    postings.map((posting) => ({
      ...posting,
      data: {
        ...posting.data,
        favorited: favoriteKeys.includes(
          `${posting.type.charAt(0).toUpperCase()}${posting.type.slice(1)}:${posting.data.id}`
        ),
      },
    }))
  );

  const removePosting = (postingId: number) => {
    setVisiblePostings((current) => current.filter((posting) => posting.id !== postingId));
  };

  return (
    <div className="row row-cols-1 row-cols-md-2 row-cols-lg-3">
      {visiblePostings.map((posting) => (
        <UnifiedCard
          key={posting.id}
          posting={posting}
          signedIn={signedIn}
          onBlocked={() => removePosting(posting.id)}
        />
      ))}
    </div>
  );
}
